export default __webpack_public_path__ + "static/media/CO@3x.99b0d605.png";